import React, {useState} from "react";
import {Form, Row, Col, Button} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./SearchbarSingleRoute.css";
import BookingModal from "./BookingModal";

const SearchbarSingleRoute = (props) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedReturnDate, setSelectedReturnDate] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);

  // Heutiges Datum um Mitternacht (ohne Zeit)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Datum in 2 Monaten
  const twoMonthsFromNow = new Date();
  twoMonthsFromNow.setMonth(twoMonthsFromNow.getMonth() + 2);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    // Wenn Rückfahrtdatum vor Hinfahrtdatum liegt, zurücksetzen
    if (selectedReturnDate && date && selectedReturnDate < date) {
      setSelectedReturnDate(null);
    }
  };

  const handleReturnDateChange = (date) => {
    setSelectedReturnDate(date);
  };

  const handleBookingClick = () => {
    setShowBookingModal(true);
  };

  const handleCloseBookingModal = () => {
    setShowBookingModal(false);
  };

  // Berechne Mindestdatum für Rückfahrt (Tag nach Hinfahrt)
  const minReturnDate = selectedDate
    ? new Date(selectedDate.getTime() + 24 * 60 * 60 * 1000)
    : today;

  return (
    <div className="searchbar-single-route">
      <Form>
        <Row>
          <Col xs={props.isRoundTrip ? 3 : 4}>
            <Form.Group controlId="formBasicEmail">
              <Form.Control
                type="text"
                placeholder="Starthafen wählen..."
                onClick={(event) => {
                  props.handleItemClick(event);
                  props.handleShowModalSelectPort("loading");
                }}
                value={
                  props.selectedPortofLoading &&
                  props.selectedPortofLoading.name
                    ? props.selectedPortofLoading.name
                    : ""
                }
                readOnly
              />
            </Form.Group>
          </Col>

          <Col xs={props.isRoundTrip ? 3 : 4}>
            <Form.Group controlId="formBasicPassword">
              <Form.Control
                type="text"
                placeholder="Zielhafen wählen..."
                disabled={
                  props.selectedPortofLoading &&
                  props.selectedPortofLoading.name
                    ? false
                    : true
                }
                onClick={(event) => {
                  props.handleItemClick(event);
                  props.handleShowModalSelectPort("discharge");
                }}
                value={
                  props.selectedPortofDischarge &&
                  props.selectedPortofDischarge.name
                    ? props.selectedPortofDischarge.name
                    : ""
                }
                readOnly
              />
            </Form.Group>
          </Col>

          <Col xs={props.isRoundTrip ? 2 : 2}>
            <Form.Group controlId="formBasicDate">
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                minDate={today}
                maxDate={twoMonthsFromNow}
                monthsShown={2}
                dateFormat="dd.MM.yyyy"
                placeholderText="Hinfahrt: TT.MM.JJJJ"
                className="form-control"
                disabled={
                  props.selectedPortofDischarge &&
                  props.selectedPortofDischarge.name
                    ? false
                    : true
                }
                showPopperArrow={false}
                calendarStartDay={1}
                popperPlacement="top-start"
              />
            </Form.Group>
          </Col>

          {props.isRoundTrip && (
            <Col xs={2}>
              <Form.Group controlId="formBasicReturnDate">
                <DatePicker
                  selected={selectedReturnDate}
                  onChange={handleReturnDateChange}
                  minDate={minReturnDate}
                  maxDate={twoMonthsFromNow}
                  monthsShown={2}
                  dateFormat="dd.MM.yyyy"
                  placeholderText="Rückfahrt: TT.MM.JJJJ"
                  className="form-control"
                  disabled={!selectedDate}
                  showPopperArrow={false}
                  calendarStartDay={1}
                  popperPlacement="top-start"
                />
              </Form.Group>
            </Col>
          )}

          <Col xs={2}>
            <Button
              variant="success"
              style={{width: "100%"}}
              disabled={
                props.isRoundTrip
                  ? !selectedDate || !selectedReturnDate
                  : !selectedDate
              }
              onClick={handleBookingClick}
            >
              Buchen
            </Button>
          </Col>
        </Row>
      </Form>

      <BookingModal
        show={showBookingModal}
        onHide={handleCloseBookingModal}
        selectedPortofLoading={props.selectedPortofLoading}
        selectedPortofDischarge={props.selectedPortofDischarge}
        selectedDate={selectedDate}
        selectedReturnDate={selectedReturnDate}
        isRoundTrip={props.isRoundTrip}
      />
    </div>
  );
};

export default SearchbarSingleRoute;
